import { LoginService } from "./LoginService";
import { ServiceConsts } from "./ServiceConsts";
import { ApiService } from "./ApiService";

export class ActivityService {
    static async getActivities(topicId, count, after) {
        return ApiService.get(
            ServiceConsts.API_URL + "/activities/topics/" + topicId,
            "count=" + count + (after ? "&before=" + after : ""),
        );
    }
}
